import { MapPin } from "lucide-react";
import { AREAS } from "@/data/site";
import { Eyebrow, Reveal } from "./Reveal";

export const Areas = () => (
  <section id="areas" data-testid="areas-section" className="bg-white py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[1fr_1.6fr]">
      <Reveal>
        <Eyebrow>Service areas</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-black leading-[0.95] sm:text-6xl">At your <span className="font-serif-i font-normal text-[var(--leaf)]">front door.</span></h2>
        <p className="mt-6 max-w-sm text-base text-[var(--muted)] md:text-lg">Based in Pleasant View, TN and serving the Greater Nashville area and surrounding towns.</p>
      </Reveal>
      <Reveal delay={0.1} className="flex flex-wrap content-start gap-x-2 gap-y-3">
        {AREAS.map((a, i) => (
          <span
            key={a}
            data-testid={`area-${a.toLowerCase().replace(/\s+/g, "-")}`}
            className={`inline-flex items-center gap-2 rounded-full px-5 py-3 font-display text-lg font-bold transition-colors duration-300 sm:text-2xl ${i === 0 ? "bg-[var(--leaf)] text-white" : "border border-[var(--leaf)]/20 text-[var(--ink)] hover:bg-[var(--sprout)]"}`}
          >
            {i === 0 && <MapPin className="h-5 w-5" />}
            {a}
            {i === 0 && <span className="font-serif-i text-base font-normal text-white/80">home base</span>}
          </span>
        ))}
      </Reveal>
    </div>
  </section>
);
